import { createSlice } from "@reduxjs/toolkit";

export const SMSSlice = createSlice({
  name: "sms",
  initialState: {
    isCheckedSMS: false,
    isSMSInValid: null,
    sms: "",
  },
  reducers: {
    changeSMS: (state, action) => {
      state.sms = action.payload;
    },
    changeIsCheckedSMS: (state, action) => {
      state.isCheckedSMS = action.payload;
    },
    changeIsSMSInvalid: (state, action) => {
      state.isSMSInValid = action.payload;
    },
  },
});

export const { changeSMS, changeIsCheckedSMS, changeIsSMSInvalid } =
  SMSSlice.actions;
export default SMSSlice.reducer;
